export const API_HELPER_INITIATED = 'API_HELPER_INITIATED';
export const APP_OFFLINE = 'APP_OFFLINE';
export const APP_ONLINE = 'APP_ONLINE';
export const DEACTIVATE_TAB = 'DEACTIVATE_TAB';
export const DEVICE_FLAGGED_FOR_DOB_VIOLATION = 'DEVICE_FLAGGED_FOR_DOB_VIOLATION';
export const DEVICE_UNFLAGGED_FOR_DOB_VIOLATION = 'DEVICE_UNFLAGGED_FOR_DOB_VIOLATION';
export const SET_DOB_VIOLATION_TIMEOUT = 'SET_DOB_VIOLATION_TIMEOUT';
export const GET_EXPERIMENTS = 'GET_EXPERIMENTS';
export const GET_EXPERIMENTS_SUCCESS = 'GET_EXPERIMENTS_SUCCESS';
export const GET_EXPERIMENTS_ERROR = 'GET_EXPERIMENTS_ERROR';
export const LEVERS_PARSED = 'LEVERS_PARSED';
export const SET_AV_PERMISSION_STATUS = 'SET_AV_PERMISSION_STATUS';
export const SET_BRANDING = 'SET_BRANDING';
export const SET_APP_SOURCE = 'SET_APP_SOURCE';
export const SET_AUTH_ATTRIBUTION_DATA = 'SET_AUTH_ATTRIBUTION_DATA';

export const ENABLE_REDUX_DEVTOOLS =
  __DEVELOPMENT__ || (__CLIENT__ && /\?devtools/.test(window.location.search));

export const AV_PERMISSION_STATUS_INIT = 0;
export const AV_PERMISSION_STATUS_GRANTED = 1;
export const AV_PERMISSION_STATUS_DENIED = 2;
export const AV_PERMISSION_NOT_SUPPORTED = 3;
